import { Transition } from "@headlessui/react"
import Image from "next/image"
import { useState, useEffect } from "react"

export default function LoadingOverlay({ show }: { show: boolean }) {
  const [showOverlay, setShowOverlay] = useState(true)

  useEffect(() => {
    // Set a timeout to potentially hide the overlay after 3 seconds
    const timerId = setTimeout(() => {
      // After 3 seconds, the overlay visibility depends on loadingConfigurator
      setShowOverlay(show)
    }, 2500)

    // Cleanup the timer if the component unmounts or if loadingConfigurator changes
    return () => clearTimeout(timerId)
  }, [show])

  return (
    <Transition
      show={showOverlay}
      enter="transition-opacity duration-1000"
      enterFrom="opacity-100"
      enterTo="opacity-100"
      leave="transition-opacity duration-1000"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="fixed inset-0 bg-black z-50 h-full w-full flex items-center justify-center">
        <Image src="/nwvl-loading-animation.gif" alt="Loading..." width="400" height="400" />
      </div>
    </Transition>
  )
}
